import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const NewIndex = lazy(() => import('./new/Index'))
const Index = lazy(() => import('./Index'))

export const QuoteRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--quote']}>
    <Route path=':id' element={<NewIndex />} />
    <Route path='new/*' element={<NewIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
